import { Component, ChangeDetectorRef } from "@angular/core";

@Component({
  selector: "progress-bar",
  template: `<div class="progress progress-nis text-center">
    <div [style.width.%]="_progress" [class]="_state"></div>
    <span>{{ _progress }}%</span>
  </div> `,
})
export class ProgressBarComponent {
  _progress: number = 0;
  _state: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  set progress(progress) {
    this._progress = progress;
    if (this._progress > 75) {
      this._state = "progress-bar success-alt";
      if (this._progress === 100) {
        this._state = "progress-bar completed";
      }
    } else if (this._progress > 50) {
      this._state = "progress-bar success";
    } else if (this._progress > 25) {
      this._state = "progress-bar warning";
    } else {
      this._state = "progress-bar danger";
    }
    this.changeDetectorRef.detectChanges();
  }

  get progress() {
    return this._progress;
  }
}
